<template>
  <section class="upcoming-renewals">
    <button type="button" class="upcoming-renewals__toggle" :aria-expanded="String(open)" @click="toggle">
      Upcoming renewals <span aria-hidden="true">{{ open ? '−' : '+' }}</span>
    </button>
    <div v-if="open" class="upcoming-renewals__body">
      <p>Verified scheduled renewals for the next seven days. Times use your local timezone.</p>
      <p v-if="error" role="alert">{{ error }}</p>
      <p v-if="checkedAt">Last checked {{ date(checkedAt) }}. A schedule does not confirm a successful payment.</p>
      <div v-if="items.length" class="upcoming-renewals__scroll">
        <table>
          <thead><tr><th>Renewal date</th><th>Customer</th><th>Subscription</th><th>Amount</th></tr></thead>
          <tbody><tr v-for="item in items" :key="item.jobId">
            <td>{{ date(item.dueAt) }}</td><td>{{ item.firstName }}<br>{{ item.email }}</td>
            <td>{{ item.productName }}</td><td>{{ money(item) }}</td>
          </tr></tbody>
        </table>
      </div>
      <p v-if="loaded && !items.length && !error">{{ nextCursor ? 'No matching renewals in the records checked so far. Continue checking for more.' : 'No verified matching renewals were found in this seven-day window.' }}</p>
      <div class="upcoming-renewals__actions">
        <button type="button" :disabled="loading" @click="load(true)">{{ loading ? 'Checking…' : 'Refresh' }}</button>
        <button v-if="nextCursor" type="button" :disabled="loading" @click="load(false)">Check more records</button>
      </div>
      <p class="upcoming-renewals__note">This list covers supported recurring schedules. Trials, discounts and installment plans may not appear. Your transaction tools remain below.</p>
    </div>
  </section>
</template>

<script>
import axios from 'axios';
import { parseUpcomingPage, mergeUpcoming } from '@/helpers/upcomingRenewals';
export default {
  data() { return { open: false, loading: false, loaded: false, items: [], nextCursor: null, error: '', checkedAt: null }; },
  methods: {
    toggle() { this.open = !this.open; if (this.open && !this.loaded && !this.loading) this.load(true); },
    async load(reset) {
      if (this.loading) return;
      this.loading = true; this.error = '';
      const cursor = reset ? '0' : this.nextCursor;
      try {
        const response = await axios.get('billing-recovery/upcoming', { params: { cursor }, timeout: 20000 });
        const page = parseUpcomingPage(response.data, cursor);
        this.items = mergeUpcoming(reset ? [] : this.items, page.items);
        this.nextCursor = page.nextCursor; this.checkedAt = new Date().toISOString(); this.loaded = true;
      } catch (_) {
        this.error = 'Upcoming renewals could not be refreshed. Any rows shown are from the last successful check. You can still use your transaction tools below.';
      } finally { this.loading = false; }
    },
    date(value) { return new Date(value).toLocaleString(); },
    money(item) { return new Intl.NumberFormat(undefined, { style: 'currency', currency: item.currency }).format(item.amountMinor / 100); }
  }
};
</script>

<style scoped>
.upcoming-renewals { margin-bottom: 20px; background: white; border: 1px solid #e2e5ef; border-radius: 14px; }
.upcoming-renewals__toggle { display: flex; justify-content: space-between; width: 100%; padding: 16px 20px; color: #263047; font-weight: 600; text-align: left; }
.upcoming-renewals__body { padding: 0 20px 20px; color: #4d5872; }
.upcoming-renewals__body p { margin-bottom: 12px; }
.upcoming-renewals__scroll { overflow-x: auto; }
table { width: 100%; text-align: left; border-collapse: collapse; }
th, td { padding: 12px; border-bottom: 1px solid #eef0f6; white-space: nowrap; }
th { color: #75809a; font-weight: 500; }
.upcoming-renewals__actions { display: flex; gap: 12px; margin-top: 16px; }
.upcoming-renewals__actions button { border: 1px solid #dce1ed; padding: 8px 14px; border-radius: 8px; color: #263047; }
button:disabled { opacity: .6; cursor: wait; }
button:focus-visible { outline: 2px solid #ef287f; outline-offset: 2px; }
.upcoming-renewals__note { margin-top: 16px; font-size: 12px; }
</style>
